module.exports = __webpack_public_path__ + "img/w10-cover.a1c63d9d.jpg";